import React from 'react';
import styled, { css } from 'styled-components';

interface Props {
  width?: number;
  height?: number;
  color?: string;
  open?: boolean;
  animateTransition?: boolean;
  className?: string;
}

const ChevronIconAnimation = ({
  width = 24,
  height = 24,
  color = 'currentColor',
  open = false,
  animateTransition = true,
  className = '',
}: Props) => (
  <StyledChevron
    width={width}
    height={height}
    open={open}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    animateTransition={animateTransition}
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5731 14.993L6.29534 10.7192C5.90155 10.3253 5.90155 9.68777 6.29534 9.29389C6.69015 8.90204 7.32918 8.90204 7.72195 9.29389L11.9997 13.5687L16.2765 9.29389C16.6723 8.90204 17.3104 8.90204 17.7031 9.29389C18.099 9.68675 18.099 10.3243 17.7031 10.7192L13.4253 14.993L12.713 15.7046C12.3182 16.0985 11.6802 16.0985 11.2864 15.7046L10.5731 14.993Z"
      fill={color}
    />
  </StyledChevron>
);

export default ChevronIconAnimation;

const StyledChevron = styled.svg<{ open: boolean; animateTransition: boolean }>`
  ${({ open }) =>
    open &&
    `
      transform: rotate(180deg);
    `}

  ${({ animateTransition }) =>
    animateTransition &&
    css`
      ${({ open }: { open: boolean }) =>
        open
          ? 'transition: transform .2s ease-in'
          : 'transition: transform 0.2s ease-out;'}
    `}
`;
